export default __webpack_public_path__ + "static/media/cybersecurity.c409e3e9.svg";